import { iaRa, mString } from 'lib/helpers/utility';

import { Alert } from 'components/shared/Alert/Alert';
import Typography from 'components/shared/Typography/Typography';
import Hint from 'components/shared/shared/Hint';

import PaymentMethods from '../../PaymentContent/PaymentMethods';
import { useLetter } from '../LetterContext';
import { buildDisclosureMessage } from '../lib/copy';
import {
  PHASE_DRIVEN_COPY,
  getHealthcareProgramDisclosureCopy,
  isSelfPayPhase
} from '../lib/helpers';

import PreviewMethodTiles from './PreviewMethodTiles';

const { paymentMethods: COPY } = PHASE_DRIVEN_COPY;

const PaymentMethodsSection = () => {
  const { mode, config, activePhaseField, amounts, appointment } = useLetter();
  const activePhase = iaRa(config?.phases).find((p) => p.field === activePhaseField);
  const isSelfPay = isSelfPayPhase(activePhase);
  const { choiceClause, scopeClause, capLabel, isCap } = getHealthcareProgramDisclosureCopy(
    activePhase,
    amounts,
    appointment?.oon_patient_responsibility ?? null
  );
  const capNode = isCap ? <strong>{capLabel}</strong> : capLabel;
  const isInteractive = mode === 'interactive';

  const dollarCapCents = Number(activePhase?.charge_limit?.config?.dollar_cap) || 0;
  const isDollarCapAlert =
    (activePhase?.field === 'in_network' || activePhase?.field === 'self_pay') &&
    activePhase?.charge_limit?.route_to === 'set-dollar-amount' &&
    dollarCapCents > 0;
  const dollarCapLabel = mString(dollarCapCents);

  const disclosureMessage = buildDisclosureMessage({ choiceClause, scopeClause, capNode });

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex flex-col gap-1">
        <Typography variant="p" size="medium" weight="medium">
          Payment methods
        </Typography>
        <Typography variant="p" size="small" color="neutral-700">
          {isSelfPay ? COPY.selfPaySubtitle : COPY.subtitle}
        </Typography>
      </div>
      {isInteractive ? <PaymentMethods /> : <PreviewMethodTiles />}
      <Hint
        iconSize={14}
        icon="info-filled"
        hint="If your final cost is lower, the card used will be refunded. If higher, we'll securely charge the same card for the difference based on your insurer's final payment."
        className="items-start"
        iconShade={700}
      />
      {isDollarCapAlert && (
        <Alert
          message={
            <span>
              <strong>{COPY.capNoteLabel}</strong> {dollarCapLabel}. {COPY.capNoteSuffix}
            </span>
          }
          icon="danger-mono"
          color="warning"
          variant="lighter"
          className="h-fit w-full"
        />
      )}
      <Alert
        title="Healthcare Program disclosure"
        message={disclosureMessage}
        icon="bulb-filled"
        variant="lighter"
        className="w-full"
      />
    </div>
  );
};

export default PaymentMethodsSection;
